import { graphql, Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { BodySwitch } from '../components/bodySwitch'
import HTMLBlock from '../components/html-content'
import Title from '../components/titles'
import styled from 'styled-components'
import Button from '../components/button'
import Layout from '../components/layout'
import Responsive from '../components/responsive'
import Seo from '../components/seo'
import colors from '../theme/colors'
import get from 'lodash.get'

const BusinessCase = ({ data, uri }) => {
    const { title, baseline, key_words, cover, body } = get(data, 'prismicBusinessCase.data')
    const image = get(cover, 'thumbnails.cover_landscape.localFile.childImageSharp.gatsbyImageData')
    const tags = key_words ? key_words.split(',') : []

    return (
        <>
            <Seo title={title.text} description={''} />
            <Layout uri={uri} withMiniHeader>
                <StyledSection>
                    <Responsive>
                        <StyledImage alt={cover.alt} image={image} />

                        <StyledHeader>
                            <Title as='h1' size='large' bold withDot>
                                {title.text}
                            </Title>

                            <HTMLBlock>{baseline.html}</HTMLBlock>

                            {tags.length > 0 && (
                                <StyledTagContainer>
                                    {tags.map((tag, index) => {
                                        return (
                                            <StyledTag key={`${tag}-${index}`}>
                                                {tag}
                                            </StyledTag>
                                        )
                                    })}
                                </StyledTagContainer>
                            )}
                        </StyledHeader>

                        <BodySwitch body={body} />
                    </Responsive>
                </StyledSection>

                <StyledNavigation>
                    <Responsive>
                        <Link to={'/'}>
                            <Button direction='rtl' icon='ArrowLeft'>
                                Retour
                            </Button>
                        </Link>
                    </Responsive>
                </StyledNavigation>
            </Layout>
        </>
    )
}

const StyledSection = styled.section`
  padding: 0 0 4rem;
  overflow: hidden;
`

const StyledNavigation = styled.nav`
  background: ${colors.beige50};
  backdrop-filter: blur(10px);
  padding: 1rem 0;

  ${Responsive} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`

const StyledImage = styled(GatsbyImage)`
  width: 100%;
  height: auto;
  object-fit: cover;
`

const StyledHeader = styled.div`
  margin-bottom: 4rem;
`

const StyledTagContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 1rem;
  flex-wrap: wrap;
`

const StyledTag = styled.span`
  background-color: ${colors.beige};
  border-radius: 6px;
  padding: 6px 10px;
`

export const query = graphql`
    query($uid: String!) {
        prismicBusinessCase(uid: { eq: $uid }) {
            id
            data {
                title {
                    text
                }
                baseline {
                    text,
                    html
                }
                cover {
                    alt
                    thumbnails {
                      cover_landscape {
                        localFile {
                          childImageSharp {
                            gatsbyImageData
                          }
                        }
                      }
                    }
                }
                key_words
                body {
                ... on PrismicBusinessCaseBodyRichTextSlice {
                  id
                  slice_type
                  primary {
                    text {
                      html
                    }
                  }
                }
                ... on PrismicBusinessCaseBodyImageSlice {
                  id
                  slice_type
                  primary {
                    image {
                        alt
                        localFile {
                            childImageSharp {
                              gatsbyImageData
                            }
                        }
                    }
                  }
                }
                ... on PrismicBusinessCaseBodyKpiSlice {
                  id
                  slice_type
                  items {
                    kpi_number
                    kpi_label
                  }
                }
                ... on PrismicBusinessCaseBodyTextImage {
                  id
                  slice_type
                  primary {
                    text_first
                    image_position
                    image_style
                    image_radius
                    content {
                      html
                    }
                    image {
                      alt
                      localFile {
                        childImageSharp {
                          gatsbyImageData
                        }
                      }
                    }
                  }
                }
              }
            }
        }
    }
`

export default BusinessCase
